import React, { FC } from "react";

import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { Spin } from "antd";

import { Content, Layout } from "./styles";

const PageLoading: FC = () => {
  return (
    <Layout>
      <Content>
        <Spin size="large" delay={200} indicator={<LoadingOutlined spin />} />
      </Content>
    </Layout>
  );
};

export default PageLoading;
